import type { Sites } from '@studio/types';

/**
 * Whether the backend knows about the passcode fields. Read off the response because
 * `SitePUT` drops unknown properties behind a success response.
 *
 * Must key on `protection`, not `passcode`: responses omit null fields, so a public site
 * has no `passcode` key even where the backend supports one.
 */
const isPasscodeSupported = (site?: Pick<Sites.Get.Sites, 'protection'>) => {
  if (!site) return false;

  return site.protection !== undefined;
};

export default isPasscodeSupported;
